module.exports = __webpack_public_path__ + "static/img/laboratory-chart-pic2.45cdae80.png";